<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    label="Справочники"
    no-data-text="Справочник не найден"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { FormsHandbookApi as Api } from '@/api/resources'
import {
  formsHandbookMapper as StoreMapper,
} from '@/views/FormsHandbook/store/cache'

import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompleteFormsHandbook',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new Api()
    this.adapter = new Adapter(api)
  },
  mounted() {
    this.$refs.autocomplete.onSearchInput()
    this.focus()
  },
  methods: {
    ...StoreMapper.mapActions(['getList']),
    request(params, ...args) {
      return this.getList(params, args)
    },
  },
}
</script>
